import React from 'react';
import framework from 'utils/framework';
const { wrapFunctionalComponent } = framework;
import RwdAdvocacy from 'components/Campaigns/RwdAdvocacy';

const Referrer = () => {
    return <RwdAdvocacy />;
};

export default wrapFunctionalComponent(Referrer, 'Referrer');
